module.exports = [
    {
        type: Object,
        isHeader: false,
        icon: 'fa el-icon-edit',
        name_th: 'การจัดการ',
        items: [{
            name: ['ListOperator', 'Add_ListOperator', 'Edit_ListOperator'],
            name_th: 'จัดการรายชื่อบริษัทของผู้ให้บริการ',
            icon: 'fa el-icon-s-cooperation',
            router: { name: '/Admin/ListOperator' },
            link: '/Admin/ListOperator'
        }, {
            name: ['Typegroup', 'Add_typegroup', 'Edit_typegroup'],
            name_th: 'จัดการกลุ่มบริษัทของผู้ให้บริการโทรศัพท์เคลื่อนที่',
            icon: 'fa el-icon-s-shop',
            router: { name: '/Admin/Typegroup' },
            link: '/Admin/Typegroup'
        }, {
            name: ['Upload_save'],
            name_th: 'นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล',
            icon: 'fa el-icon-document-checked',
            router: { name: '/Admin/Upload_save' },
            link: '/Admin/Upload_save'
        }, {
            name: ['Manage_averagetosave', 'Manage_averageAdd', 'Manage_averageEdit'],
            name_th: 'จัดการรายชื่ออัตราค่าบริการเพื่อการกำกับดูแล',
            icon: 'fa el-icon-s-tools',
            router: { name: '/Admin/Manage_average' },
            link: '/Admin/Manage_average'
        }, {
            name: ['Manage_service', 'Edit_service'],
            name_th: 'จัดการข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่',
            icon: 'fa el-icon-s-tools',
            router: { name: '/Admin/Manage_service' },
            link: '/Admin/Manage_service'
        }, {
            name: ['Manage_mobile_service', 'Edit_mobile_service'],
            name_th: 'จัดการสัดส่วนรายการส่งเสริมการขาย โปรวินาที และ โปรนาที',
            icon: 'fa el-icon-s-tools',
            router: { name: '/Admin/Manage_mobile_service' },
            link: '/Admin/Manage_mobile_service'
        }, {
            name: ['Manage_mobile', 'Add_promotion_mobile', 'History_mobile', 'History_mobile_operator', 'Add_file_promotion', 'History_mobileAdmin'],
            name_th: 'จัดการข้อมูลรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่',
            icon: 'fa el-icon-mobile',
            router: { name: '/Admin/Manage_mobile' },
            link: '/Admin/Manage_mobile'
        }, {
            name: ['Manage_request_mobile'],
            name_th: 'จัดการคำร้องของผู้ให้บริการโทรศัพท์เคลื่อนที่',
            icon: 'fa el-icon-message',
            router: { name: '/Admin/Manage_request_mobile' },
            link: '/Admin/Manage_request_mobile'
        }]
    }, {
        type: Object,
        isHeader: false,
        icon: 'fa fa-bar-chart-o',
        name_th: 'รายงาน',
        items: [{
            name: ['Report_promotion_mobile_type'],
            name_th: 'รายงานจำนวนรายการส่งเสริมการขายบริการโทรศัพท์เคลื่อนที่จำแนกตามประเภทบริการ',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/Report_promotion_mobile_type' },
            link: '/Admin/Report_promotion_mobile_type'
        }, {
            name: ['Services_rate'],
            name_th: 'รายงานอัตราค่าบริการต่างๆของบริการโทรศัพท์เคลื่อนที่',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/Services_rate' },
            link: '/Admin/Services_rate'
        }, {
            name: ['Program_technologies'],
            name_th: 'รายงานตารางอัตราค่าบริการเฉลี่ยของการกำกับดูแลและอัตราค่าบริการเฉลี่ยบริการโทรศัพท์เคลื่อนที่ของแต่ละผู้ให้บริการ',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Program_technologies' },
            link: '/Admin/Program_technologies'
        }, {
            name: ['Services_change'],
            name_th: 'รายงานการเปลี่ยนแปลงอัตราค่าบริการเฉลี่ยเปรียบเทียบกับอัตราอ้างอิงในการกำกับดูแล',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/Services_change' },
            link: '/Admin/Services_change'
        }, {
            name: ['Pro_seconds_G5'],
            name_th: 'รายงานตารางรายการส่งเสริมการขายที่เสนอขายในตลาด (โปรวินาทีต้องไม่น้อยกว่า 50%)',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Pro_seconds_G5' },
            link: '/Admin/Pro_seconds_G5'
        }, {
            name: ['Promotion_table_avg'],
            name_th: 'รายงานตารางรายการส่งเสริมการขายค่าเฉลี่ยค่าบริการและการเปลี่ยนแปลงอัตราค่าบริการในไตรมาส',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Promotion_table_avg' },
            link: '/Admin/Promotion_table_avg'
        }, {
            name: ['Promotion_percent'],
            name_th: 'รายงานร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของแต่ละผู้ให้บริการ',
            icon: 'fa el-icon-s-marketing',
            router: { name: '/Admin/Promotion_percent' },
            link: '/Admin/Promotion_percent'
        }, {
            name: ['Services_trends'],
            name_th: 'รายงานแนวโน้มอัตราค่าบริการโปรวินาทีและโปรนาทีของแต่ละผู้ให้บริการ',
            icon: 'fa el-icon-s-marketing',
            router: { name: '/Admin/Services_trends' },
            link: '/Admin/Services_trends'
        }, {
            name: ['Reportview_promotion'],
            name_th: 'รายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Reportview_promotion' },
            link: '/Admin/Reportview_promotion'
        }, {
            name: ['Manage_data'],
            name_th: 'จัดเก็บข้อมูลจากเว็บไซต์ผู้ให้บริการ',
            icon: 'fa el-icon-s-platform',
            router: { name: '/Admin/Manage_data' },
            link: '/Admin/Manage_data'
        }, {
            name: ['Report_blockchain', 'Report_blockchainDetail'],
            name_th: 'รายงานแสดงการรับ-ส่งข้อมูลในบล็อกเชน (BlockChain)',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Report_blockchain' },
            link: '/Admin/Report_blockchain'
        }, {
            name: ['Popular_proMobile'],
            name_th: 'โปรโมชันเด่นของบริการโทรศัพท์เคลื่อนที่',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Popular_proMobile' },
            link: '/Admin/Popular_proMobile'
        }, {
            name: ['Report_promotion_ranking'],
            name_th: 'รายงานจัดอันดับรายการส่งเสริมการขาย',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/Report_promotion_ranking' },
            link: '/Admin/Report_promotion_ranking'
        }, {
            name: ['User_behavior'],
            name_th: 'รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/User_behavior' },
            link: '/Admin/User_behavior'
        }, {
            name: ['Uteleme'],
            name_th: 'รายงานพฤติมาตร',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/Uteleme' },
            link: '/Admin/Uteleme'
        }]
    }
]
